<template>
<div>
  <div class="row">

      <div class="col-md-12 card">
          <div class="card-header">
              <div class="row">
                <div class="col-md-4">
                  <h5 class="title">{{ $t('trainers') }}</h5>
                </div>
                <div class="col-md-4">
                 <fg-input>
                    <el-select size="large" class="select-primary" v-model="country" filterable clearable :placeholder="$t('select_country')">
                        <el-option
                          class="select-primary"
                          v-for="country in Countries"
                          :key="country.id"
                          :label="country.name"
                          :value="country.name"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-4">
                  <fg-input>
                      <el-select size="large" class="select-primary" v-model="ngo" filterable clearable :placeholder="$t('select_ngo')">
                          <el-option
                            class="select-primary"
                            v-for="ngo in NGO"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.name"></el-option>
                      </el-select>
                  </fg-input>
               </div>
              </div>
              <hr>
          </div>
          <div class="card-body">
             <div class="row">
                  <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm"
                      :placeholder="$t('search')"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
             </div>
             <div class="row">
                  <el-table v-loading="loading" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                    <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
                       <template slot-scope="props">
                            <p-button type="success" size="sm" icon @click="viewTrainer(props.$index, props.row)">
                              <i class="fa fa-eye"></i>
                            </p-button>
                       </template>
                    </el-table-column>
                  </el-table>
             </div>

          </div>
          <div class="card-footer">
             <div class="row">
                <div class="col-sm-6 pagination-primary">
                  <p class="category">{{$t('showing')}} {{pagination.from}} {{$t('to')}} {{pagination.to}} {{$t('of')}} {{pagination.total}} {{$t('entries')}}</p>
                </div>
                <div class="col-sm-6">
                  <p-pagination
                    class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"></p-pagination>
                </div>
             </div>
          </div>
      </div>

  </div>

</div>
</template>
<script>
  import Resource from "@/util/Api/resource.js";
  import PPagination from "src/components/UIComponents/Pagination.vue";
  import Modal from "src/components/UIComponents/Modal.vue";
  import { Message } from "element-ui";

  const TrainerResource = new Resource("user/list");
  const CatResources = new Resource("category/childrenGivenParent");
  const UpdateUserResource = new Resource("user/update");
  const UserDeleteResource = new Resource("user/delete");

  export default {
      components: {
        PPagination,
        Modal,
     },
     data() {
       return {
          tableColumns: [
            {prop: "name",label: this.$t("name"),},
            {prop: "surname",label: this.$t("surname"),},
            {prop: "email",label: this.$t("email"),},
            {prop: "ngo",label: this.$t("foundation"),},
            {prop: "country",label: this.$t("in_country")},
          ],
          modals: {
            classic: false
          },
          loading: false,
          searchQuery: "",
          tableData: [],
          NGO:[],
          Countries:[],
          country:'',
          ngo:'',
          pagination:{
              perPage: 10,
              perPageOptions: [10, 20, 30, 60, 500, 1000],
              currentPage:1,
              nextPage:'',
              prevPage:'',
              total:'',
              from:'',
              to:'',
              page:'',
          },
       }
     },

     methods: {

        // view user page
        viewTrainer(prop, row) {
            localStorage.setItem("trainerID", row.id);
            localStorage.setItem("roleID", row.role ? row.role.id : '');
            this.$router.push({
                name: "TrainerDetail",
                params: { post: row }
            });
        },

        // show message dialog
        showAlertMessage(message, type) {
          this.$message.closeAll();
          this.$message({
            type: type,
            message: message
          });
        },

        // get all trainers
        async getAllTrainers(){
            this.loading = true;
            await TrainerResource.get(3).then((response) => {
              this.tableData = response.data;
              this.loading = false;
            }).catch((error) => {
              this.showAlertMessage(error.response.data.message, "error");
            });
        },

        // Get all NGOs in a categories
        async getNGOs() {
          await CatResources.get(1).then(response => {
            this.NGO = response.data;
          }).catch(error => {
            this.showAlertMessage(error.response.data.message, "error");
          });
        },

        // Get all countries in a category
        async getCountry() {
          await CatResources.get(2).then(response => {
            this.Countries = response.data;
          }).catch(error => {
            this.showAlertMessage(error.response.data.message, "error");
          });
        },


        paginate(array, length, pageNumber){
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            this.pagination.page = Math.ceil(array.length / length);
            this.pagination.total = array.length;
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },

     },

     created() {
        this.getAllTrainers();
        this.getNGOs();
        this.getCountry();
     },

     computed: {

        queriedData() {
             let result = this.tableData;
              if (this.searchQuery) {
                  result = result.filter((row) => {
                      return Object.keys(row).some((key) => {
                          return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                      })
                  });
              } else if(this.country){
                result = result.filter((row) => {
                      return Object.keys(row).some((key) => {
                          return (String(row[key]).toLowerCase().indexOf(this.country.toLowerCase()) > -1);
                      })
                });
              } else if(this.ngo){
                result = result.filter((row) => {
                      return Object.keys(row).some((key) => {
                          return (String(row[key]).toLowerCase().indexOf(this.ngo.toLowerCase()) > -1);
                      })
                });
              }
              return result;
        },

        paginated(){
            return this.paginate(this.queriedData, this.pagination.perPage, this.pagination.currentPage);
        },

     },
  }
</script>
